/**
 * Authentication layout component
 * Provides consistent layout for login, register, and other auth pages
 */
import React from 'react';
import { Outlet } from 'react-router-dom';

/**
 * Authentication layout component
 * @returns JSX Element
 */
const AuthLayout: React.FC = () => {
  return <Outlet />;
};

export default AuthLayout;
